import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import Bao from "./../../services/bao-service";
import * as $ from "jquery";
import * as ko from "knockout";
import GenericListTab from "./../../factories/generic-list-tab";
import WorkItem from "../work-item";
import BaoDialog from "./../../factories/bao-dialog";
import { WorkItemAssignmentTypes } from "./../../constants/work-Item-assignment-types"

/**
 * View-Model for Assignment tab in WorkItem 
 * */
class WorkItemAssignmentTab extends GenericListTab {
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.Parent = parent; 
        this.SaveAllowed = parent.SaveAllowed;
        this.Models.subscribe(() => {
            this.Selection([]);
        });
        this.SelectedObjectUser.subscribe(() => {
            if (this.SelectedObjectUser()) {
                this.AddAssignmentObject("WorkItemAssignment/AssignUser", this.PrepareDefaultParamtersToAssign());
            }
        });
        this.SelectedObjectRole.subscribe(() => {
            if (this.SelectedObjectRole()) {
                this.AddAssignmentObject("WorkItemAssignment/AssignRole", this.PrepareDefaultParamtersToAssign());
            }
        });
        this.SelectedObjectServiceProvider.subscribe(() => {
            if (this.SelectedObjectServiceProvider()) {
                this.AddAssignmentObject("WorkItemAssignment/AssignServiceProvider", this.PrepareDefaultParamtersToAssign());
            }
        });
        this.SelectedObjectShiftbook.subscribe(() => {
            if (this.SelectedObjectShiftbook()) {
                this.AddAssignmentObject("WorkItemAssignment/AssignShiftbook", this.PrepareDefaultParamtersToAssign());
            }
        });
        this.SelectedObjectShiftType.subscribe(() => {
            if (this.SelectedObjectShiftType()) {
                const paramteres: string[] = this.SelectedObjectShiftType().map(item => {
                    return JSON.stringify({
                        sessionTabId: this.SessionTabId,
                        workItemId: this.Parent.WorkItemId(),
                        workItemTypeId: this.Parent.WorkItemTypeId(),
                        shiftbookId: item.ShiftbookId,
                        shiftTypeId: item.ShiftTypeId,
                        name: item.ShiftbookDescription
                    });
                });

                this.AddAssignmentObject("WorkItemAssignment/AssignShiftType", paramteres);
            }
        });

    }
    Parent: WorkItem;
    SaveAllowed: KnockoutObservable<boolean>;
    ControllerUrl = "WorkItemAssignment";
    SelectedObjectId: KnockoutObservableArray<string> = ko.observableArray();
    SelectedObjectUser: KnockoutObservableArray<any> = ko.observableArray();
    SelectedObjectRole: KnockoutObservableArray<any> = ko.observableArray();
    SelectedObjectServiceProvider: KnockoutObservableArray<any> = ko.observableArray();
    SelectedObjectShiftbook: KnockoutObservableArray<any> = ko.observableArray();
    SelectedObjectShiftType: KnockoutObservableArray<any> = ko.observableArray();
    InitBasedOnSerialTask: KnockoutObservable<boolean> = ko.observable(false);

    CustomFilter(): Models.HashObject[] {
        let customFilterHashObject: Models.HashObject[] = [];
        if (this.InitBasedOnSerialTask()) {
            customFilterHashObject.push({
                Key: 'WorkItemId',
                Value: this.Parent.PrimaryWorkItemId()
            });
            customFilterHashObject.push({
                Key: 'BaseOnSerialTask',
                Value: true
            });
        }
        return customFilterHashObject;
    }

    init = (): JQueryPromise<void> => {
        if (this.Parent.IsBasedOnVirtual()) {
            this.InitBasedOnSerialTask(true);
        }
        return super.init()
            .always(_ => this.InitBasedOnSerialTask(false));
    }

    ItemCompleteCheck(): JQueryPromise<boolean> {
        let def = $.Deferred<boolean>();
        def.resolve(true);
        return def.promise();
    }
    public Edit(item) {
        if (item != null) {
            this.Dialog(ko.unwrap(item.PrimaryKeyValue));
        }
    }

    CustomToolbarClick(button: Interfaces.Bao.BaoMenuItem) {
        let key = ko.unwrap(button.ActionKey);
        if (key === "WorkItemAssignmentAddUser") {
            this.ShowWorkItemAssignmentDialogUser();
        }
        else if (key === "WorkItemAssignmentAddRole") {
            this.ShowWorkItemAssignmentDialogRole();
        }
        else if (key === "WorkItemAssignmentAddServiceProvider") {
            this.ShowWorkItemAssignmentDialogServiceProvider();
        }
        else if (key === "WorkItemAssignmentAddShiftbook") {
            this.ShowWorkItemAssignmentDialogShiftbook();
        }
        else if (key === "WorkItemAssignmentAddShiftType") {
            this.ShowWorkItemAssignmentDialogShiftType();
        }
    };

    ShowWorkItemAssignmentDialogUser = function () { };
    ShowWorkItemAssignmentDialogRole = function () { };
    ShowWorkItemAssignmentDialogServiceProvider = function () { };
    ShowWorkItemAssignmentDialogShiftbook = function () { };
    ShowWorkItemAssignmentDialogShiftType = function () { };

    AddAssignmentObject(url: string, parameters: string[]) {
        this.TabPage.IsLoading(true);
        parameters.reduce((prevPromise: Promise<any>, item: string) => {
            return prevPromise.then(() => {
                return this.SaveSelectedItem(url, item)
                    .then((serverResult: boolean) => {
                        if (!serverResult) {
                            Promise.reject();
                        }
                    });
            });
        },
            Promise.resolve()
        )
            .then(() => {
                return this.Get().then(() => {
                    this.TabPage.DirtyFlag(true);
                });
            })
            .catch(() => {
                this.TabPage.IsLoading(false);
            });
    }

    /**
     *  Overridden Method - Enable/Disable - Toolbar Buttons
     */
    ToggleToolbarButtons() {
        super.ToggleToolbarButtons();

        ko.utils.arrayForEach(this.ToolbarButtons(), (button) => {
            var key = ko.unwrap(button.ActionKey);
            var enabled = <KnockoutObservable<boolean>>(button.Enabled);
            if (key == this.PermissionRemove) {
                enabled(this.Selection() != null && this.Selection().length > 0 && this.Selection()[0].WorkItemAssignmentTypeId != WorkItemAssignmentTypes.AUTHOR);
            }
        });
    }

    //#region Protected Methods

    /**
     *  Returns the default parameters as json to the endpoint that assigns the object to the workitem
     * @returns JSON
     */
    protected PrepareDefaultParamtersToAssign(): string[] {
        return this.SelectedObjectId().map(item => {
            return JSON.stringify({
                sessionTabId: this.SessionTabId,
                workItemId: this.Parent.WorkItemId(),
                workItemTypeId: this.Parent.WorkItemTypeId(),
                id: item
            });
        });
    }

     /**
      * Assigns an object to a workitem
      * @param url Endpoint url
      * @param parameter Parameters as json
      * @returns
      */
    protected SaveSelectedItem(url: string, parameter: string): JQueryPromise<boolean> {
        return Bao.post(url, parameter, (serverResult: {
            Message: string;
            Result: boolean;
        }) => {
            if (serverResult.Result) {
                return true;
            }
            else {
                new BaoDialog(Bao.Session.ApplicationName, serverResult.Message, "info");
                return false;
            }
        });
    }

    //#endregion

}
export default WorkItemAssignmentTab;